import Vue from 'vue'

import {
  Button,
  Collapse,
  CollapseItem,
  Tabs,
  Tab,
  Icon,
  NavBar,
  Image,
  Swipe,
  SwipeItem,
  Slider,
  ImagePreview,
  CountDown,
  Form,
  Field,
  Uploader,
  Popup,
  Divider,
  DatetimePicker,
  RadioGroup,
  Radio,
  Stepper,
  List,
  Empty,
  Toast,
  Progress,
  Col,
  Row,
  Popover,
  Picker,
  TreeSelect

} from 'vant'

Vue.use(Button)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(Icon)
Vue.use(NavBar)
Vue.use(Image)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Slider)
Vue.use(ImagePreview)
Vue.use(CountDown)
Vue.use(Form)
Vue.use(Field)
Vue.use(Uploader)
Vue.use(Popup)
Vue.use(Divider)
Vue.use(DatetimePicker)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Stepper)
Vue.use(List)
Vue.use(Empty)
Vue.use(Toast)
Vue.use(Progress)
Vue.use(Col)
Vue.use(Row)
Vue.use(Popover)
Vue.use(Picker)
Vue.use(TreeSelect)

